import { translate } from '../../../util/translate'

export const headers = [
  {
    text: translate['hausefulInvoices.headers.customer'],
    value: 'real_estate'
  },
  {
    text: translate['hausefulInvoices.headers.status'],
    value: 'status',
    width: 200,
  },
  {
    text: translate['hausefulInvoices.headers.comment'],
    value: 'comment',
    width: 400,
  },
  {
    text: translate['hausefulInvoices.headers.transfer'],
    value: 'transfer',
    align: 'center',
    width: 120,
  },
  {
    text: translate['hausefulInvoices.headers.total'],
    value: 'total',
    align: 'end',
    width: 180,
  },
  {
    text: translate['hausefulInvoices.headers.actions'],
    value: 'actions',
    align: 'end',
    width: 120,
  },
]

export const paymentHeaders = [
  {
    text: translate['hausefulInvoices.headers.createdAt'],
    value: 'created_at',
    width: 200,
  },
  {
    text: translate['hausefulInvoices.headers.code'],
    value: 'code'
  },
  {
    text: translate['hausefulInvoices.headers.description'],
    value: 'description',
  },
  {
    text: translate['hausefulInvoices.headers.value'],
    value: 'total',
    align: 'end',
  }
]

export const branchHeaders = [
  {
    text: translate['hausefulInvoices.headers.customer'],
    value: 'customer',
    width: 450,
  },
  {
    text: translate['hausefulInvoices.headers.branch'],
    value: 'name',
    width: 450,
  },
  {
    text: translate['hausefulInvoices.headers.total'],
    value: 'total',
    align: 'end',
  },
  {
    text: translate['hausefulInvoices.headers.actions'],
    value: 'actions',
    align: 'end',
    width: 100,
  },
]

export const invoiceHeaders = [
  {
    text: translate['hausefulInvoices.headers.code'],
    value: 'code',
  },
  {
    text: translate['hausefulInvoices.headers.description'],
    value: 'description',
  },
  {
    text: translate['hausefulInvoices.headers.date'],
    value: 'date',
  },
  {
    text: translate['hausefulInvoices.headers.value'],
    value: 'value',
    align: 'end',
  },
]
